import React, { Component } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { changeColorOpacity, ifNavAllowed } from '../../helpers/general_helpers';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserShield, faDashboard, faUsers, faGraduationCap, faDownload, faAward, faUserTie, faUsersLine, faChartColumn, faListCheck, faUserCog, faUsersViewfinder, faHouseUser } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';

class HRPayrollSidebar extends Component {

  state = {
    nav: [
      {
        id: 'hr-dashboard',
        name: 'HR Dashboard',
        icon: faDashboard,
        path: '/hr-dashboard'
      },
      {
        id: 'employees',
        name: 'Employees',
        icon: faUserTie,
        path: '/employees'
      },
      {
        id: 'class-assignment',
        name: 'Class Assignment',
        icon: faUserTie,
        path: '/class-assignment'
      },
      {
        id: 'user-rights',
        name: 'User Rights',
        icon: faUserCog,
        path: '/user-rights'
      },
      {
        id: 'evaluation',
        name: 'Evaluation',
        icon: faUsersLine,
        path: '/evaluation'
      },
      {
        id: 'employee-parents',
        name: 'Employee Parents',
        icon: faHouseUser,
        path: '/employee-parents'
      },
      {
        id: 'hr-reports',
        name: 'HR Reports',
        icon: faChartColumn,
        path: '/hr-reports'
      },
      {
        id: 'employee-attendance',
        name: 'Employee Attendance',
        icon: faListCheck,
        path: '/employee-attendance'
      },
    ],
  }

  render() {

    const { lang_orientation: dir } = this.props.defaultLanguage;

    return (
      <div className='inner-blue-bar'
        style={{
          backgroundColor: changeColorOpacity(brand_colors[this.props.defaultTheme.theme_id].sidebar_bg, 0.15),
          marginRight: dir == 1 ? 0 : 15,
          marginLeft: dir == 0 ? 0 : 15,
        }}>
        <ul>
          {this.state.nav.map((item, index) => (
            (ifNavAllowed(item.id))
              ? <li key={index}>
                <NavLink
                  activeclassname='active'
                  to={item.path}
                >
                  <FontAwesomeIcon
                    icon={item.icon}
                  />
                  <div className='px-2'>{t(item.name)}</div>
                </NavLink>
              </li>
              : null
          )
          )}
        </ul>
      </div>

    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(HRPayrollSidebar);
